module.exports = __webpack_public_path__ + "img/SkylineAugustLogos_Black_Hover.9c5489bb.svg";